import React, { useState, useLayoutEffect, useContext } from 'react'
import { TableDataContext } from '../index';
export default function DueTable(props) {
    const { AllDashBoardData } = useContext(TableDataContext);
    const [loadData, setLoadData] = useState({ data: [], show: false })
    useLayoutEffect(() => {
        if (AllDashBoardData?.DueInvoice?.data?.length > 0) {
            let Data = AllDashBoardData?.DueInvoice?.data
            if (Data?.length > 20) {
                setLoadData({ ...loadData, data: [].concat(Data?.slice(0, 20)) })
            } else {
                setLoadData({ ...loadData, data: Data })
            }
        } else {
            setLoadData({ show: false, data: [] });
        }
    }, [AllDashBoardData?.DueInvoice?.data])
    const LoadMore = () => {
        let newData = []
        if (loadData?.data?.length != AllDashBoardData?.DueInvoice?.data?.length) {
            newData = loadData?.data?.concat(AllDashBoardData?.DueInvoice?.data?.slice(loadData?.data?.length, loadData?.data?.length + 20));
        } else {
            newData = [].concat(AllDashBoardData?.DueInvoice?.data?.slice(0, 20))
        }
        setLoadData({ ...loadData, data: newData });
    }
    const downloadCsv = () => {
        const csvContent = [];
        const rowCollection = [];
        AllDashBoardData?.DueInvoice?.data?.forEach((ticket) => {
            const rowData = {
                'Invoice Number': ticket.invoice_num,
                'Amount': ticket?.amount ? `$${ticket?.amount}` : `$0`,
                'Batch Name': ticket?.name || '-',
            };
            rowCollection.push(rowData);
        });
        const headers = ['Invoice Number', 'Amount', 'Batch Name'];
        csvContent.push(headers);

        // Add data rows
        rowCollection.forEach((rowData) => {
            const values = headers.map((h) => rowData[h]);
            csvContent.push(values);
        });

        const csvString = csvContent.map(row => row.join(',')).join('\n');
        const blob = new Blob([csvString], { type: 'text/csv' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'due_invoices_report.csv';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <React.Fragment>
            <div className="col-12  greyBoxShadow" style={{ height: "100%" }}>
                <div className="pb-5 w-100">
                    <div className="row mt-2 px-2 time" >
                        <div className='Header col-md-8'>
                            <b className='font-15'>Due Invoices</b><br />
                        </div>
                        <div className='col-md-4 text-end'>
                            <b className='cursor-pointer text-decoration-underline' onClick={downloadCsv}>Download CSV</b>
                        </div>
                    </div>
                    <hr className="my-2" />
                    {AllDashBoardData?.DueInvoice?.loader ? <div className='row'><div className="col-12 text-center pt-2"><img src="/images/loder.svg" className="" style={{ width: "30px" }} /></div></div> : <>
                        <table className="table data-table">
                            <thead className='GridHeader'>
                                <tr>

                                    <th scope="col" className='fw-600 font-14'>Invoice #</th>
                                    <th scope="col" className='fw-600 font-14' >Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                {AllDashBoardData?.DueInvoice?.data?.length > 0 ?
                                    loadData?.data?.map((item, i) => (
                                        <tr className='OddEvenClass tableBorderHide py-3' key={item?.id}>
                                            <td>{item?.invoice_num || "-"}</td>
                                            <td>${item?.amount}</td>
                                        </tr>
                                    )) :
                                    <tr className='OddEvenClass tableBorderHide py-3'>
                                        <td colSpan={4} className='text-center'> No Record Found</td>
                                    </tr>

                                }
                            </tbody>
                        </table></>}

                    {
                        AllDashBoardData?.DueInvoice?.data?.length > 20 && <div className="col-12 p-2 admin-table-border-top">
                            <span style={{ textDecoration: "underline", cursor: "pointer", color: "var(--primary-color)" }} onClick={() => LoadMore()}> {loadData?.data?.length == AllDashBoardData?.DueInvoice?.data?.length ? "Hide" : "Load More"}</span>
                        </div>
                    }
                </div>
            </div>
        </React.Fragment>
    )
}
